module.exports = __webpack_public_path__ + "img/06_bg.2514ece7.jpg";